import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type ContextValueType } from '../types';
import META from './useTrackContextValueAdded.meta';

export type UseTrackContextValueAddedParams = {
  source: 'onboarding' | 'add_domain' | 'agent' | 'manual';
  value_type: ContextValueType;
  field_name: string;
  label: boolean;
  ai_instruction: boolean;
};

export const useTrackContextValueAdded = () => {
  const { track } = useAnalyticsUtilities();

  const trackContextValueAdded = useCallback(
    (params: UseTrackContextValueAddedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackContextValueAdded };
};
